import { GUEST_WISHLIST_KEY, type GuestWishlist } from "../wishlist";

export const guestWishlistUtils = {
  getWishlist: (): GuestWishlist => {
    try {
      const wishlistData = localStorage.getItem(GUEST_WISHLIST_KEY);
      if (wishlistData) {
        return JSON.parse(wishlistData);
      }
    } catch (error) {
      console.error("Error reading guest wishlist:", error);
    }
    return { items: [] };
  },

  addToWishlist: (productId: string): GuestWishlist => {
    try {
      const currentWishlist = guestWishlistUtils.getWishlist();

      // Check if product already exists
      if (!currentWishlist.items.some(item => item.productId === productId)) {
        currentWishlist.items.push({
          type: "product",
          priority: 1,
          public: true,
          quantity: 1,
          productId,
        });

        localStorage.setItem(
          GUEST_WISHLIST_KEY,
          JSON.stringify(currentWishlist),
        );
      }

      return currentWishlist;
    } catch (error) {
      console.error("Error adding to guest wishlist:", error);
      return { items: [] };
    }
  },

  removeFromWishlist: (productId: string): GuestWishlist => {
    try {
      const currentWishlist = guestWishlistUtils.getWishlist();

      currentWishlist.items = currentWishlist.items.filter(
        item => item.productId !== productId,
      );

      localStorage.setItem(GUEST_WISHLIST_KEY, JSON.stringify(currentWishlist));
      return currentWishlist;
    } catch (error) {
      console.error("Error removing from guest wishlist:", error);
      return { items: [] };
    }
  },

  clearWishlist: (): void => {
    try {
      localStorage.removeItem(GUEST_WISHLIST_KEY);
    } catch (error) {
      console.error("Error clearing guest wishlist:", error);
    }
  },

  isInWishlist: (productId: string): boolean => {
    try {
      const currentWishlist = guestWishlistUtils.getWishlist();
      if (currentWishlist.items && currentWishlist.items.length) {
        return currentWishlist.items.some(item => item.productId === productId);
      }
      return false;
    } catch (error) {
      console.error("Error checking guest wishlist:", error);
      return false;
    }
  },
};
